const disabledStyles = `
    iris:cursor-not-allowed
    iris:pointer-events-none
    iris:opacity-(--sem-opacity-interactive-disabled)
    `;

export { disabledStyles };
